// extracted by mini-css-extract-plugin
export default {"row":"ut3koq6rErHAbaOF5boDNg== body-2","label":"dY63AJkCgANQc8xhEQ24TA==","danger":"MDb0IunMDBLrXLaFd79BOg==","content":"_7bYokSFuIAagRHq8rbk7GQ=="};